<template>
  <!-- Outlines shown in place while an asset page loads, so nothing moves down and no old layout shows through
       (as on the system page, US 9370) -->
  <div v-if="part === 'hero'" class="sx-hero is-loading" aria-hidden="true" qid="page-hero-loading">
    <span class="sx-hero__logo"></span>
    <div class="sx-hero__main">
      <span class="sx-skel is-short"></span>
      <span class="sx-skel is-title"></span>
      <span class="sx-skel is-long"></span>
      <span class="sx-skel is-tags"></span>
    </div>
    <div class="sx-hero__people">
      <span class="sx-skel is-short"></span>
      <span class="sx-skel is-avatar"></span>
      <span class="sx-skel is-short"></span>
    </div>
    <div class="sx-hero__done">
      <span class="sx-skel is-ring"></span>
      <span class="sx-skel is-short"></span>
    </div>
    <div class="sx-hero__act">
      <span class="sx-skel is-button"></span>
    </div>
  </div>
  <div v-else-if="part === 'head'" class="pp-chead is-loading" aria-hidden="true" qid="page-head-loading">
    <span class="pp-chead__icon"></span>
    <div class="pp-chead__main">
      <span class="ps-skel is-name"></span>
      <span class="ps-skel is-line"></span>
    </div>
  </div>
  <nav v-else-if="part === 'tabs'" class="sx-tabs mt-3 is-loading" aria-hidden="true" qid="page-tabs-loading">
    <span v-for="n in 4" :key="n" class="ps-skel is-tab"></span>
  </nav>
  <div v-else class="pp-loading" aria-hidden="true" qid="page-cards-loading">
    <div v-for="n in 2" :key="n" class="v2-card pp-loading__card">
      <span class="ps-skel is-name"></span>
      <span class="ps-skel is-line"></span>
      <span class="ps-skel is-line is-short"></span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'V2PageLoading',
    props: {
      // hero, head (a child's header), tabs or cards
      part: { type: String, default: 'cards' }
    }
  };
</script>
